var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{staticClass:"mb-2",attrs:{"label-class":"pb-1"}},[_c('template',{slot:"label"},[_c('b',[_vm._v("Company: ")])]),_c('vue-single-select',{attrs:{"classes":{
      input: 'form-control',
      dropdown: 'dropdown p-0',
    },"options":_vm.companies,"optionLabel":"companyName"},model:{value:(_vm.company),callback:function ($$v) {_vm.company=$$v},expression:"company"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }